module.exports = __webpack_public_path__ + "img/large1.b57f0314.jpg";